/**
 * analytics.js — đẩy sự kiện đo lường vào window.dataLayer (GTM đọc, chuyển sang GA4).
 *
 * Gắn bằng thuộc tính, không phải viết JS cho từng nút:
 *   [data-track="tên_sự_kiện"]           bấm phần tử (hoặc gửi <form>) → bắn sự kiện
 *   [data-track-label="…"]               nhãn đi kèm (chip nào, ô giá nào…)
 *   [data-track-view="view_item_list"]   khối vào khung nhìn lần đầu (≥ 40%) → bắn một lần
 *   [data-track-list="home_featured"]    tên danh sách cho item_list_name
 *   [data-track-links="journal_click"]   mọi link bên trong khối bắn sự kiện này (kèm link_text;
 *                                        data-track-label trên khối cũng đi theo — vd ô "Pháp" trong
 *                                        tab "Nước sản xuất" → axis_tile_click label nuoc-san-xuat)
 * Phần tử nằm trong [data-product][data-product-id] thì kèm mảng items chuẩn GA4
 * (item_id, item_name, price) — tra từ window.WBCatalog ở bản tĩnh.
 *
 * API cho module khác: window.WBTrack('tên', { … }).
 * WP: giữ nguyên file; GTM bắt event theo tên. Bật Debug: localStorage wb_debug_track = 1
 * để in sự kiện ra console.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    window.dataLayer = window.dataLayer || [];

    function debug() {
        try {
            return window.localStorage.getItem('wb_debug_track') === '1';
        } catch (e) {
            return false;
        }
    }

    function track(event, params) {
        var payload = { event: event };
        var key;
        params = params || {};
        for (key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key) && params[key] !== undefined && params[key] !== '') {
                payload[key] = params[key];
            }
        }
        window.dataLayer.push(payload);
        if (debug() && window.console) window.console.log('[track]', payload);
    }

    function itemOf(el) {
        var holder = el.closest('[data-product]');
        if (!holder) return null;
        var id = holder.getAttribute('data-product-id');
        var live = window.WBCatalog ? window.WBCatalog.get(id) : null;
        var title = holder.querySelector('h3, h2');
        return {
            item_id: id,
            item_name: title ? title.textContent.trim() : live && live.name,
            price: live ? live.price : undefined
        };
    }

    function paramsOf(el) {
        var list = el.closest('[data-track-list]');
        var item = itemOf(el);
        return {
            label: el.getAttribute('data-track-label') || undefined,
            item_list_name: list ? list.getAttribute('data-track-list') : undefined,
            items: item ? [item] : undefined,
            link_url: el.getAttribute('href') || undefined
        };
    }

    document.addEventListener('click', function (event) {
        if (!event.target.closest) return;

        var el = event.target.closest('[data-track]');
        if (el && el.tagName !== 'FORM') {
            track(el.getAttribute('data-track'), paramsOf(el));
        }

        var link = event.target.closest('a[href]');
        var area = link && link.closest('[data-track-links]');
        if (area) {
            track(area.getAttribute('data-track-links'), {
                label: area.getAttribute('data-track-label') || undefined,
                link_url: link.getAttribute('href'),
                // data-track-text khi link chứa thêm số đếm / mô tả (ô "Chọn vang": chỉ lấy tên mục)
                link_text: link.getAttribute('data-track-text') || link.textContent.trim().slice(0, 100)
            });
        }
    });

    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form.matches || !form.matches('[data-track]')) return;
        var search = form.querySelector('input[name="s"]');
        track(form.getAttribute('data-track'), { search_term: search ? search.value.trim() : undefined });
    });

    // Khối danh sách vào khung nhìn → view_item_list với toàn bộ sản phẩm trong khối
    var views = [].slice.call(document.querySelectorAll('[data-track-view]'));
    if (views.length && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    observer.unobserve(entry.target);
                    var block = entry.target;
                    var items = [].slice.call(block.querySelectorAll('[data-product]')).map(function (card, index) {
                        var item = itemOf(card);
                        item.index = index;
                        return item;
                    });
                    track(block.getAttribute('data-track-view'), {
                        item_list_name: block.getAttribute('data-track-list') || undefined,
                        items: items
                    });
                });
            },
            { threshold: 0.4 }
        );
        views.forEach(function (block) {
            observer.observe(block);
        });
    }

    window.WBTrack = track;
})();
